import { render, staticRenderFns } from "./AppPromoFooter.vue?vue&type=template&id=44db51dc&scoped=true"
import script from "./AppPromoFooter.vue?vue&type=script&lang=js"
export * from "./AppPromoFooter.vue?vue&type=script&lang=js"
import style0 from "./AppPromoFooter.vue?vue&type=style&index=0&id=44db51dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44db51dc",
  null
  
)

export default component.exports